import ProductProjectionsStoreBasedProjectionParams from "@commercetools-local/topics/product-projections/store-based-projection-params.mdx";
import ProductProjectionsLocalesBasedProjectionParamsLocaleProjection from "@commercetools-local/topics/product-projections/locales-based-projection-params-localeProjection.mdx";
import * as React from 'react';
export default {
  ProductProjectionsStoreBasedProjectionParams,
  ProductProjectionsLocalesBasedProjectionParamsLocaleProjection,
  React
};